import React from "react";
import { Link } from "react-router-dom";
import ProseSection from "../../ui/ProseSection";

const Query = () => (
  <ProseSection highlight className="!pb-20">
    <p>
      Didn&apos;t find what you were looking for? Or is that the areas of interest are not something you particularly specialise in?.
    </p>
    <p>Well, we don&apos;t believe in disappointing interested folks</p>
    <p>More so if they&apos;re interested in kindness!</p>
    <h2 className="font-display text-2xl font-bold text-ku-royal">
      So, here&apos;s the good news: You could still join us in this journey of kindness!
    </h2>
    <p>
      Kindly fill in this <Link to="/contactus">form</Link> to help us know more about how you&apos;d like to help KU accelerate its journey of kindness. <br />
      We&apos;ve kept it simple, short & direct.
    </p>
    <p>
      Rest assured, we will get back to you within 24 hrs. of receiving the form.
    </p>
    <blockquote className="border-l-4 border-ku-violet pl-6 my-8 italic text-ku-royal font-display text-xl">
      &lsquo;Life&apos;s most urgent and persistent question is, What are you doing for others?&rsquo;
      <footer className="text-base not-italic text-ku-violet mt-2 font-accent">Martin Luther King, Jr.</footer>
    </blockquote>
  </ProseSection>
);

export default Query;
